import React from 'react';
import PropTypes from 'prop-types';
import {Animate, Box, Button, Heading, Text} from '@tenancy.nz/design-system';

function EnquirySuccess({address = undefined, onBack = undefined}) {
  return (
    <Animate>
      <Box>
        <Heading as="h2" gutterBottom>
          Thank you for your enquiry.
        </Heading>
        <Text paragraph>
          Your request will be reviewed, and you&#39;ll be contacted if further
          action is needed.
        </Text>
        {address && (
          <Text sx={{mt: '25px'}} paragraph>
            Property address:
            <br />
            <strong>{address}</strong>
          </Text>
        )}
        {onBack && (
          <Box>
            <Button color="primary" onClick={onBack} fill>
              Back to properties
            </Button>
          </Box>
        )}
      </Box>
    </Animate>
  );
}

EnquirySuccess.propTypes = {
  /**
   * Full property address
   */
  address: PropTypes.string,

  /**
   * Callback function to navigate back
   */
  onBack: PropTypes.func,
};

export default EnquirySuccess;
